// ----------------------------------------------------------------------

export default function List(theme) {
  return {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          minWidth: "auto",
          // marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: "auto",
          // marginRight: theme.spacing(2),
        },
      },
    },
    "MuiListItemText-primary": {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0,
          fontSize: "10px !important",
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
  };
}
